<ng-container *ngIf="(builderService.nodes$ | async) as nodes; else empty">

    <!-- ✅ Controles do canvas: APENAS em modo EDIT -->
    <div class="canvas-controls" *ngIf="isEditMode">
      <button 
        nz-button 
        nzType="default" 
        nzSize="small"
        (click)="toggleGridOverlay()"
        [nzTitle]="'builderScreen.canvas.toggleGrid' |translateTA"
        nz-tooltip>
        <nz-icon nzType="border" nzTheme="outline"></nz-icon>
        {{ showGridOverlay ? ('builderScreen.canvas.hideGrid' |translateTA) : ('builderScreen.canvas.showGrid' |translateTA) }}
      </button>
  
      <!-- CORREÇÃO CRÍTICA: Controles de rolagem para melhor UX quando o conteúdo é rolável -->
      <div class="scroll-controls" *ngIf="(builderService.nodes$ | async)!.length > 3">
        <button 
          nz-button 
          nzType="text" 
          nzSize="small"
          (click)="scrollToTop()"
          [nzTitle]="'builderScreen.canvas.scrollToTop' |translateTA"
          nz-tooltip>
          <nz-icon nzType="up" nzTheme="outline"></nz-icon>
        </button>
        <span class="component-count">
          {{ (builderService.nodes$ | async)!.length }} {{ 'builderScreen.canvas.components' |translateTA }}
        </span>
        <button 
          nz-button 
          nzType="text" 
          nzSize="small"
          (click)="scrollToBottom()"
          [nzTitle]="'builderScreen.canvas.scrollToBottom' |translateTA"
          nz-tooltip>
          <nz-icon nzType="down" nzTheme="outline"></nz-icon>
        </button>
      </div>
    </div>
  
  
    <div class="canvas-scroll-container">
  
      <div class="canvas-grid-container" 
           *ngIf="(gridPositions$ | async) as positions"
           [ngClass]="{ 'show-overlay': showGridOverlay }"
           [style.min-height.px]="600">
      
  
      <!-- ✅ Grid overlay: APENAS em modo EDIT -->
      <div class="grid-overlay" *ngIf="showGridOverlay && isEditMode">
        <div class="grid-cell" 
             *ngFor="let i of getGridCells(gridHeight$ | async); trackBy: trackByIndex">
        </div>
      </div>
  
  
      <div 
        class="canvas-node"
        *ngFor="let node of getRootNodes(nodes); trackBy: trackById"
        [ngClass]="{ 'is-selected': (builderService.selectedId$ | async) === node.id }"
        [class.viewmode-hidden]="node.type === 'panel' && isPanelHiddenByViewMode(node.id)"
        [ngStyle]="getNodeWrapperStyle(node, getGridPosition(node.id, positions))"
        (click)="builderService.selectNode(node.id)"
      >
        <ng-container [ngSwitch]="node.type">
          <ng-container *ngSwitchCase="'text'">
            <div class="component-wrapper">
            <label class="node-label">{{ node.props?.label |translateTA }}</label>
            <input nz-input 
              [attr.data-component-id]="node.id"
              [placeholder]="(node.props?.placeholder |translateTA) || ''" 
              [ngStyle]="{
                'background-color': node.props?.backgroundColor || null,
                'color': node.props?.textColor || null
              }" />
              <button 
                nz-button 
                nzSize="small" 
                nzType="text" 
                nzShape="circle"
                [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                [attr.aria-label]="'builderScreen.canvas.remove' |translateTA"
                nz-tooltip
                (click)="onRemoveNode(node, $event)"
                class="remove-button">
                <nz-icon nzType="close" nzTheme="outline"></nz-icon>
              </button>
            </div>
          </ng-container>
  
          <ng-container *ngSwitchCase="'textarea'">
            <div class="component-wrapper">
            <label class="node-label">{{ node.props?.label |translateTA }}</label>
            <textarea nz-input 
              [attr.data-component-id]="node.id"
              [attr.rows]="node.props?.minRows || 4" 
              [placeholder]="(node.props?.placeholder |translateTA) || ''"
              [ngStyle]="{
                'background-color': node.props?.backgroundColor || null,
                'color': node.props?.textColor || null
              }"></textarea>
              <button 
                nz-button 
                nzSize="small" 
                nzType="text" 
                nzShape="circle"
                [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                [attr.aria-label]="'builderScreen.canvas.remove' |translateTA"
                nz-tooltip
                (click)="onRemoveNode(node, $event)"
                class="remove-button">
                <nz-icon nzType="close" nzTheme="outline"></nz-icon>
              </button>
            </div>
          </ng-container>
  
          <ng-container *ngSwitchCase="'tabs'">
            <nz-tabs 
              nzTabPosition="top" 
              (nzSelectedIndexChange)="onTabsIndexChange(node, $event)"
              class="custom-tabset-container"
              [ngStyle]="{
                '--tab-bg-color': node.props?.backgroundColor || null,
                '--tab-text-color': node.props?.textColor || null,
                '--active-tab-bg-color': node.props?.activeTabColor || null,
                '--active-tab-text-color': node.props?.activeTabTextColor || null,
                '--tab-border-color': node.props?.borderColor || null,
                '--content-bg-color': node.props?.contentBackgroundColor || null,
                '--content-text-color': node.props?.contentTextColor || null,
                '--tab-hover-bg-color': node.props?.hoverTabColor || null,
                '--tabs-container-bg-color': node.props?.tabsContainerBackgroundColor || null,
                '--tabs-container-border-color': node.props?.tabsContainerBorderColor || null,
                '--tabs-container-border-radius': node.props?.tabsContainerBorderRadius || null,
                '--tabs-container-padding': node.props?.tabsContainerPadding || null,
                'background-color': node.props?.tabsContainerBackgroundColor || null,
                'border': node.props?.tabsContainerBorderColor ? '1px solid ' + node.props?.tabsContainerBorderColor : null,
                'border-radius': node.props?.tabsContainerBorderRadius || null,
                'padding': node.props?.tabsContainerPadding || null
              }">
              <nz-tab *ngFor="let t of getTabItems(node); let i = index; trackBy: trackByTabId" 
                      [nzForceRender]="true" 
                      [nzTitle]="t.name |translateTA"
                      [attr.data-tab-id]="t.id"
                      [attr.data-tab-icon]="t.icon"
  >
                <!-- Barra de Contexto (oculta na aba principal - index 0) -->
                <div class="context-strip" *ngIf="i > 0 && getContextFields(node).length > 0">
                  <nz-icon nzType="pushpin" nzTheme="outline" class="context-strip-icon"></nz-icon>
                  <div class="context-strip-fields">
                    <div *ngFor="let cf of getContextFields(node); let last = last" class="context-field-chip">
                      <span class="context-field-label">{{ cf.label }}</span>
                      <span class="context-field-value">{{ currentSelectedRowData ? resolveContextValue(cf) : '---' }}</span>
                      <span *ngIf="!last" class="context-field-separator"></span>
                    </div>
                  </div>
                </div>
  
                <div 
                  class="tab-content-grid"
                  [attr.data-tab-content-id]="t.id"
                  [ngStyle]="{
                    'background-color': node.props?.contentBackgroundColor || 'transparent',
                    'color': node.props?.contentTextColor || null,
                    '--content-bg-color': node.props?.contentBackgroundColor || null,
                    '--content-text-color': node.props?.contentTextColor || null
                  }">
                  <ng-container *ngFor="let child of getChildrenForTab(nodes, node.id, t.id); trackBy: trackById">
                    <div class="canvas-node child" 
                         (click)="onSelectChild(child, $event)" 
                         [ngClass]="{ 'is-selected': (builderService.selectedId$ | async) === child.id }"
                         [class.viewmode-hidden]="child.type === 'panel' && isPanelHiddenByViewMode(child.id)"
                         [ngStyle]="getGridStyle(getChildGridPosition(child.id, node.id, t.id, nodes), child.props, undefined, child.id)">
                      <ng-container [ngSwitch]="child.type">
                        <ng-container *ngSwitchCase="'text'">
                          <div class="component-wrapper">
                          <label class="node-label">{{ child.props?.label |translateTA }}</label>
                          <input nz-input 
                            [attr.data-component-id]="child.id"
                            [placeholder]="(child.props?.placeholder |translateTA) || ''" 
                            [ngStyle]="{
                              'background-color': child.props?.backgroundColor || null,
                              'color': child.props?.textColor || null
                            }" />
                            <button 
                              nz-button 
                              nzSize="small" 
                              nzType="text" 
                              nzShape="circle"
                              [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                              [attr.aria-label]="'builderScreen.canvas.remove' |translateTA"
                              nz-tooltip
                              (click)="onRemoveNode(child, $event)"
                              class="remove-button">
                              <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                            </button>
                          </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'textarea'">
                          <div class="component-wrapper">
                          <label class="node-label">{{ child.props?.label |translateTA }}</label>
                          <textarea nz-input 
                            [attr.data-component-id]="child.id"
                            [attr.rows]="child.props?.minRows || 4" 
                            [placeholder]="(child.props?.placeholder |translateTA) || ''"
                            [ngStyle]="{
                              'background-color': child.props?.backgroundColor || null,
                              'color': child.props?.textColor || null
                            }"></textarea>
                            <button 
                              nz-button 
                              nzSize="small" 
                              nzType="text" 
                              nzShape="circle"
                              [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                              [attr.aria-label]="'builderScreen.canvas.remove' |translateTA"
                              nz-tooltip
                              (click)="onRemoveNode(child, $event)"
                              class="remove-button">
                              <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                            </button>
                          </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'number'">
                          <div class="component-wrapper">
                            <label class="node-label">{{ child.props?.label |translateTA }}</label>
                            <nz-input-number 
                              [attr.data-component-id]="child.id"
                              [nzPlaceHolder]="(child.props?.placeholder |translateTA) || ''"
                              [nzMin]="child.props?.min || 0"
                              [nzMax]="child.props?.max || 100"
                              [nzStep]="child.props?.step || 1"
                              [nzPrecision]="child.props?.precision || 0"
                              [nzFormatter]="getNumberFormatter(child)"
                              [nzParser]="getNumberParser(child)"
                              [nzAddonBefore]="child.props?.addonBefore"
                              [nzAddonAfter]="child.props?.addonAfter"
                              [ngStyle]="{
                                'background-color': child.props?.backgroundColor || null,
                                'color': child.props?.textColor || null
                              }">
                            </nz-input-number>
                            <button 
                              nz-button 
                              nzSize="small" 
                              nzType="text" 
                              nzShape="circle"
                              [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                              [attr.aria-label]="'builderScreen.canvas.remove' |translateTA"
                              nz-tooltip
                              (click)="onRemoveNode(child, $event)"
                              class="remove-button">
                              <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                            </button>
                          </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'switch'">
                          <div class="component-wrapper" 
                            [ngStyle]="{
                              'background-color': child.props?.backgroundColor || null,
                              'color': child.props?.textColor || null
                            }">
                            <label class="node-label">{{ child.props?.label |translateTA }}</label>
                            <nz-switch 
                              [attr.data-component-id]="child.id"
                              [nzCheckedChildren]="child.props?.checkedChildren |translateTA"
                              [nzUnCheckedChildren]="child.props?.unCheckedChildren |translateTA"
                              [nzChecked]="child.props?.defaultValue || false"
                              (nzCheckedChange)="onSwitchChange(child, $event)">
                            </nz-switch>
                            <button 
                              nz-button 
                              nzSize="small" 
                              nzType="text" 
                              nzShape="circle"
                              [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                              [attr.aria-label]="'builderScreen.canvas.remove' |translateTA"
                              nz-tooltip
                              (click)="onRemoveNode(child, $event)"
                              class="remove-button">
                              <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                            </button>
                          </div>
                        </ng-container>
                        
                        <!-- NOVO: Dropdown (combo-box básico) -->
                        <ng-container *ngSwitchCase="'dropdown'">
                          <div class="component-wrapper">
                            <label class="node-label">{{ child.props?.label |translateTA }}</label>
                            <nz-select
                              [attr.data-component-id]="child.id"
                              [nzPlaceHolder]="(child.props?.placeholder |translateTA) || 'Selecione uma opção'"
                              [nzMode]="child.props?.multiple ? 'multiple' : 'default'"
                              [nzShowSearch]="child.props?.showSearch || false"
                              [ngStyle]="{
                                'background-color': child.props?.backgroundColor || null,
                                'color': child.props?.textColor || null,
                                'width': '100%'
                              }">
                              <nz-option 
                                *ngFor="let option of child.props?.options" 
                                [nzValue]="option.value" 
                                [nzLabel]="option.label">
                              </nz-option>
                            </nz-select>
                            <button 
                              nz-button 
                              nzSize="small" 
                              nzType="text" 
                              nzShape="circle"
                              [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                              [attr.aria-label]="'builderScreen.canvas.remove' |translateTA"
                              nz-tooltip
                              (click)="onRemoveNode(child, $event)"
                              class="remove-button">
                              <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                            </button>
                          </div>
                        </ng-container>
                        
                        <ng-container *ngSwitchCase="'button'">
                          <div class="component-wrapper">
                            <label class="node-label">{{ child.props?.label |translateTA }}</label>
                            <button 
                              nz-button 
                              [nzType]="child.props?.buttonType || 'default'"
                              [nzSize]="child.props?.size || 'default'"
                              [nzLoading]="child.props?.loading || false"
                              [disabled]="child.props?.disabled || false"
                              [ngStyle]="{
                                'background-color': child.props?.backgroundColor || null,
                                'color': child.props?.textColor || null,
                                'border-color': child.props?.backgroundColor || null
                              }"
                              (click)="onButtonClick(child, $event)"
                              class="canvas-button">
                              <nz-icon *ngIf="child.props?.icon" [nzType]="child.props.icon"></nz-icon>
                              {{ child.props?.text || ('builderScreen.button.defaultText' |translateTA) }}
                            </button>
                            <button 
                              nz-button 
                              nzSize="small" 
                              nzType="text" 
                              nzShape="circle"
                              [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                              [attr.aria-label]="'builderScreen.canvas.remove' |translateTA"
                              nz-tooltip
                              (click)="onRemoveNode(child, $event)"
                              class="remove-button">
                              <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                            </button>
                          </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'simpletable'">
                          <div class="component-wrapper">
                            <label class="node-label">{{ child.props?.label |translateTA }}</label>
                            <nz-table 
                              [nzData]="child.props?.dataSource || []"
                              [nzShowPagination]="false"
                              nzSize="small"
                              [ngStyle]="{
                                '--table-header-bg': child.props?.headerBackgroundColor || null,
                                '--table-header-color': child.props?.headerTextColor || null,
                                '--table-row-bg': child.props?.rowBackgroundColor || null,
                                '--table-row-color': child.props?.rowTextColor || null,
                                '--table-alt-row-bg': child.props?.alternateRowColor || null,
                                '--table-border-color': child.props?.borderColor || null,
                                '--table-hover-color': child.props?.hoverColor || null
                              }">
                              <thead>
                                <tr>
                                  <th *ngFor="let col of child.props?.columns || []; trackBy: trackByColumnKey">{{ col.label |translateTA }}</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let data of child.props?.dataSource || []; let i = index; trackBy: trackByIndex">
                                  <td *ngFor="let col of child.props?.columns || []; trackBy: trackByColumnKey">{{ data[col.key] }}</td>
                                </tr>
                              </tbody>
                            </nz-table>
                            <button 
                              nz-button 
                              nzSize="small" 
                              nzType="text" 
                              nzShape="circle"
                              [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                              [attr.aria-label]="'builderScreen.canvas.remove' |translateTA"
                              nz-tooltip
                              (click)="onRemoveNode(child, $event)"
                              class="remove-button">
                              <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                            </button>
                          </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'table'">
                          <div class="component-wrapper">
                            <label class="node-label">{{ child.props?.label |translateTA }}</label>
                            <nz-table 
                              [nzData]="child.props?.dataSource || []"
                              [nzShowPagination]="child.props?.pagination || true"
                              nzSize="small"
                              [ngStyle]="{
                                '--table-header-bg': child.props?.headerBackgroundColor || null,
                                '--table-header-color': child.props?.headerTextColor || null,
                                '--table-row-bg': child.props?.rowBackgroundColor || null,
                                '--table-row-color': child.props?.rowTextColor || null,
                                '--table-alt-row-bg': child.props?.alternateRowColor || null,
                                '--table-border-color': child.props?.borderColor || null,
                                '--table-hover-color': child.props?.hoverColor || null
                              }">
                              <thead>
                                <tr>
                                  <th 
                                    *ngFor="let col of child.props?.columns || []; trackBy: trackByColumnKey"
                                    [nzSortFn]="child.props?.sorting ? true : null"
                                    [nzShowFilter]="child.props?.filtering || false">
                                    {{ col.label |translateTA }}
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let data of child.props?.dataSource || []; let i = index; trackBy: trackByIndex">
                                  <td *ngFor="let col of child.props?.columns || []; trackBy: trackByColumnKey">{{ data[col.key] }}</td>
                                </tr>
                              </tbody>
                            </nz-table>
                            <button 
                              nz-button 
                              nzSize="small" 
                              nzType="text" 
                              nzShape="circle"
                              [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                              [attr.aria-label]="'builderScreen.canvas.remove' |translateTA"
                              nz-tooltip
                              (click)="onRemoveNode(child, $event)"
                              class="remove-button">
                              <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                            </button>
                          </div>
                        </ng-container>
  
                        <ng-container *ngSwitchCase="'spreadsheet'">
                          <div class="component-wrapper">
                            <label class="node-label">{{ child.props?.label |translateTA }}</label>
                            <app-builder-spreadsheet 
                              [props]="child.props">
                            </app-builder-spreadsheet>
                            <button 
                              nz-button 
                              nzSize="small" 
                              nzType="text" 
                              nzShape="circle"
                              [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                              [attr.aria-label]="'builderScreen.canvas.remove' |translateTA"
                              nz-tooltip
                              (click)="onRemoveNode(child, $event)"
                              class="remove-button">
                              <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                            </button>
                          </div>
                        </ng-container>
  
                        <!-- NOVO: Case para Panel dentro de Tabs -->
                        <ng-container *ngSwitchCase="'panel'">
                          <div class="panel-container" 
                               [ngStyle]="getPanelStyles(child)"
                               [class.panel-selected]="(builderService.selectedId$ | async) === child.id"
                               [class.panel-active]="child.props?.active"
                               [class.panel-collapsed]="child.props?.collapsed">
                            
                            <!-- Header do panel -->
                            <div class="panel-header">
                              <div class="panel-title">
                                <nz-icon nzType="layout" nzTheme="outline"></nz-icon>
                                <span>{{ child.props?.name || 'Panel' |translateTA }}</span>
                                <nz-tag *ngIf="child.props?.active" nzColor="processing" nzSize="small">
                                  {{ 'builderScreen.panel.active' |translateTA }}
                                </nz-tag>
                              </div>
                              
                              <!-- Controles do panel -->
                              <div class="panel-controls">
                                <button
                                  nz-button
                                  nzSize="small"
                                  nzType="text"
                                  nzShape="circle"
                                  [nzTitle]="'builderScreen.panel.collapse' |translateTA"
                                  nz-tooltip
                                  (click)="togglePanelCollapse(child)"
                                  class="collapse-button">
                                  <nz-icon
                                    [nzType]="child.props?.collapsed ? 'down' : 'up'"
                                    nzTheme="outline">
                                  </nz-icon>
                                </button>
                                
                                <button
                                  nz-button
                                  nzSize="small"
                                  nzType="text"
                                  nzShape="circle"
                                  nzDanger
                                  [nzTitle]="'builderScreen.canvas.removePanel' |translateTA"
                                  nz-tooltip
                                  (click)="onRemoveNode(child, $event)"
                                  class="remove-button">
                                  <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                                </button>
                              </div>
                            </div>
                            
                            <!-- Conteúdo do panel (campos filhos) -->
                            <div class="panel-content" 
                                 [attr.data-add-fields-text]="'builderScreen.panel.addFields' |translateTA"
                                 *ngIf="!child.props?.collapsed">
                              <ng-container *ngFor="let panelChild of getChildrenForPanel(nodes, child.id); trackBy: trackById">
                                <div class="canvas-node child"
                                     [class.selected]="(builderService.selectedId$ | async) === panelChild.id"
                                     [hidden]="shouldHideNonGridChild(child.id, panelChild.type)"
                                     (click)="onSelectChild(panelChild, $event)"
                                     [ngStyle]="getGridStyle(getPanelChildGridPosition(panelChild.id, child.id, nodes), panelChild.props, child.id)">
                                  
                                  <!-- Switch para os campos dentro do Panel -->
                                  <ng-container [ngSwitch]="panelChild.type">
                                    <ng-container *ngSwitchCase="'text'">
                                      <div class="component-wrapper" [attr.data-component-id]="panelChild.id">
                                        <!-- ⭐ NOVO: Usar webhook-adapter para data binding -->
                                        <app-webhook-adapter-beta 
                                          [node]="panelChild" 
                                          [isPreview]="isPreviewMode">
                                        </app-webhook-adapter-beta>
                                        <button 
                                          *ngIf="isEditMode"
                                          nz-button 
                                          nzSize="small" 
                                          nzType="text" 
                                          nzShape="circle"
                                          [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                                          nz-tooltip
                                          (click)="onRemoveNode(panelChild, $event)"
                                          class="remove-button">
                                          <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                                        </button>
                                      </div>
                                    </ng-container>
  
                                    <ng-container *ngSwitchCase="'textarea'">
                                      <div class="component-wrapper" [attr.data-component-id]="panelChild.id">
                                        <!-- ⭐ NOVO: Usar webhook-adapter para data binding -->
                                        <app-webhook-adapter-beta 
                                          [node]="panelChild" 
                                          [isPreview]="isPreviewMode">
                                        </app-webhook-adapter-beta>
                                        <button 
                                          *ngIf="isEditMode"
                                          nz-button 
                                          nzSize="small" 
                                          nzType="text" 
                                          nzShape="circle"
                                          [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                                          nz-tooltip
                                          (click)="onRemoveNode(panelChild, $event)"
                                          class="remove-button">
                                          <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                                        </button>
                                      </div>
                                    </ng-container>
  
                                    <ng-container *ngSwitchCase="'number'">
                                      <div class="component-wrapper" [attr.data-component-id]="panelChild.id">
                                        <!-- ⭐ NOVO: Usar webhook-adapter para data binding -->
                                        <app-webhook-adapter-beta 
                                          [node]="panelChild" 
                                          [isPreview]="isPreviewMode">
                                        </app-webhook-adapter-beta>
                                        <button 
                                          *ngIf="isEditMode"
                                          nz-button 
                                          nzSize="small" 
                                          nzType="text" 
                                          nzShape="circle"
                                          [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                                          nz-tooltip
                                          (click)="onRemoveNode(panelChild, $event)"
                                          class="remove-button">
                                          <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                                        </button>
                                      </div>
                                    </ng-container>
  
                                    <ng-container *ngSwitchCase="'switch'">
                                      <div class="component-wrapper" [attr.data-component-id]="panelChild.id">
                                        <!-- ⭐ NOVO: Usar webhook-adapter para data binding -->
                                        <app-webhook-adapter-beta 
                                          [node]="panelChild" 
                                          [isPreview]="isPreviewMode">
                                        </app-webhook-adapter-beta>
                                        <button 
                                          *ngIf="isEditMode"
                                          nz-button 
                                          nzSize="small" 
                                          nzType="text" 
                                          nzShape="circle"
                                          [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                                          nz-tooltip
                                          (click)="onRemoveNode(panelChild, $event)"
                                          class="remove-button">
                                          <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                                        </button>
                                      </div>
                                    </ng-container>

                                    <!-- NOVO: Dropdown (combo-box básico) dentro de Panel -->
                                    <ng-container *ngSwitchCase="'dropdown'">
                                      <div class="component-wrapper" [attr.data-component-id]="panelChild.id">
                                        <app-webhook-adapter-beta 
                                          [node]="panelChild" 
                                          [isPreview]="isPreviewMode">
                                        </app-webhook-adapter-beta>
                                        <button 
                                          *ngIf="isEditMode"
                                          nz-button 
                                          nzSize="small" 
                                          nzType="text" 
                                          nzShape="circle"
                                          [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                                          nz-tooltip
                                          (click)="onRemoveNode(panelChild, $event)"
                                          class="remove-button">
                                          <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                                        </button>
                                      </div>
                                    </ng-container>
  
                                    <ng-container *ngSwitchCase="'button'">
                                      <div class="component-wrapper">
                                        <button 
                                          nz-button 
                                          [attr.data-component-id]="panelChild.id"
                                          [nzType]="panelChild.props?.buttonType || 'default'"
                                          [nzSize]="panelChild.props?.size || 'default'"
                                          [nzLoading]="panelChild.props?.loading || false"
                                          [disabled]="panelChild.props?.disabled || false"
                                          [ngStyle]="{
                                            'background-color': panelChild.props?.backgroundColor || null,
                                            'color': panelChild.props?.textColor || null,
                                            'border-color': panelChild.props?.backgroundColor || null
                                          }"
                                          (click)="onButtonClick(panelChild, $event)">
                                          <nz-icon *ngIf="panelChild.props?.icon" [nzType]="panelChild.props?.icon"></nz-icon>
                                          {{ panelChild.props?.text || 'Button' }}
                                        </button>
                                        <button 
                                          *ngIf="isEditMode"
                                          nz-button 
                                          nzSize="small" 
                                          nzType="text" 
                                          nzShape="circle"
                                          [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                                          nz-tooltip
                                          (click)="onRemoveNode(panelChild, $event)"
                                          class="remove-button">
                                          <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                                        </button>
                                      </div>
                                    </ng-container>
  
                                    <ng-container *ngSwitchCase="'image'">
                                      <div class="component-wrapper">
                                        <img 
                                          [src]="panelChild.props?.imageUrl || 'https://via.placeholder.com/300x200'"
                                          [alt]="panelChild.props?.alt || 'Imagem'"
                                          [style.width.px]="panelChild.props?.width || 300"
                                          [style.height.px]="panelChild.props?.height || 200"
                                          [style.border-radius.px]="panelChild.props?.borderRadius || 0"
                                          [style.cursor]="panelChild.props?.enableLightbox ? 'pointer' : 'default'"
                                          [nz-tooltip]="panelChild.props?.tooltip"
                                          (click)="onImageClick(panelChild, $event)"
                                          class="builder-image"
                                        />
                                        <button 
                                          *ngIf="isEditMode"
                                          nz-button 
                                          nzSize="small" 
                                          nzType="text" 
                                          nzShape="circle"
                                          [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                                          nz-tooltip
                                          (click)="onRemoveNode(panelChild, $event)"
                                          class="remove-button">
                                          <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                                        </button>
                                      </div>
                                    </ng-container>
  
                                    <!-- NOVOS CASES: Tipos webhook faltantes -->
                                    <ng-container *ngSwitchCase="'divider'">
                                      <div class="component-wrapper" [attr.data-component-id]="panelChild.id" *ngIf="isWebhookComponent(panelChild.type); else fallbackDivider">
                                        <app-webhook-adapter-beta 
                                          [node]="panelChild" 
                                          [isPreview]="isPreviewMode">
                                        </app-webhook-adapter-beta>
                                        <button 
                                          *ngIf="isEditMode"
                                          nz-button 
                                          nzSize="small" 
                                          nzType="text" 
                                          nzShape="circle"
                                          [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                                          nz-tooltip
                                          (click)="onRemoveNode(panelChild, $event)"
                                          class="remove-button">
                                          <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                                        </button>
                                      </div>
                                      <ng-template #fallbackDivider>
                                        <div class="component-wrapper">
                                          <nz-divider 
                                            [nzDashed]="panelChild.props?.dashed || false"
                                            [nzType]="panelChild.props?.type || 'horizontal'"
                                            [nzOrientation]="panelChild.props?.orientation || 'center'"
                                            [ngStyle]="{ 'border-color': panelChild.props?.color || '#d9d9d9' }">
                                            {{ panelChild.props?.label |translateTA }}
                                          </nz-divider>
                                          <button 
                                            *ngIf="isEditMode"
                                            nz-button 
                                            nzSize="small" 
                                            nzType="text" 
                                            nzShape="circle"
                                            [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                                            nz-tooltip
                                            (click)="onRemoveNode(panelChild, $event)"
                                            class="remove-button">
                                            <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                                          </button>
                                        </div>
                                      </ng-template>
                                    </ng-container>
  
                                    <ng-container *ngSwitchCase="'select'">
                                      <div class="component-wrapper" [attr.data-component-id]="panelChild.id" *ngIf="isWebhookComponent(panelChild.type); else fallbackSelect">
                                        <app-webhook-adapter-beta 
                                          [node]="panelChild" 
                                          [isPreview]="isPreviewMode">
                                        </app-webhook-adapter-beta>
                                        <button 
                                          *ngIf="isEditMode"
                                          nz-button 
                                          nzSize="small" 
                                          nzType="text" 
                                          nzShape="circle"
                                          [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                                          nz-tooltip
                                          (click)="onRemoveNode(panelChild, $event)"
                                          class="remove-button">
                                          <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                                        </button>
                                      </div>
                                      <ng-template #fallbackSelect>
                                        <div class="component-wrapper">
                                          <label class="node-label">{{ panelChild.props?.label |translateTA }}</label>
                                          <nz-select 
                                            [attr.data-component-id]="panelChild.id"
                                            [nzPlaceHolder]="(panelChild.props?.placeholder |translateTA) || ''"
                                            [nzMultiple]="panelChild.props?.multiple || false"
                                            [nzShowSearch]="panelChild.props?.showSearch || false">
                                            <nz-option 
                                              *ngFor="let option of panelChild.props?.options || []" 
                                              [nzValue]="option.value" 
                                              [nzLabel]="option.label">
                                            </nz-option>
                                          </nz-select>
                                          <button 
                                            *ngIf="isEditMode"
                                            nz-button 
                                            nzSize="small" 
                                            nzType="text" 
                                            nzShape="circle"
                                            [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                                            nz-tooltip
                                            (click)="onRemoveNode(panelChild, $event)"
                                            class="remove-button">
                                            <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                                          </button>
                                        </div>
                                      </ng-template>
                                    </ng-container>
  
                                    <!-- Para os outros tipos webhook complexos, usar sempre o webhook-adapter -->
                                    <ng-container *ngSwitchCase="'tag'">
                                      <div class="component-wrapper" [attr.data-component-id]="panelChild.id">
                                        <app-webhook-adapter-beta 
                                          [node]="panelChild" 
                                          [isPreview]="isPreviewMode">
                                        </app-webhook-adapter-beta>
                                        <button 
                                          *ngIf="isEditMode"
                                          nz-button 
                                          nzSize="small" 
                                          nzType="text" 
                                          nzShape="circle"
                                          [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                                          nz-tooltip
                                          (click)="onRemoveNode(panelChild, $event)"
                                          class="remove-button">
                                          <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                                        </button>
                                      </div>
                                    </ng-container>
  
                                    <ng-container *ngSwitchCase="'keyValueObject'">
                                      <div class="component-wrapper" [attr.data-component-id]="panelChild.id">
                                        <app-webhook-adapter-beta 
                                          [node]="panelChild" 
                                          [isPreview]="isPreviewMode">
                                        </app-webhook-adapter-beta>
                                        <button 
                                          *ngIf="isEditMode"
                                          nz-button 
                                          nzSize="small" 
                                          nzType="text" 
                                          nzShape="circle"
                                          [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                                          nz-tooltip
                                          (click)="onRemoveNode(panelChild, $event)"
                                          class="remove-button">
                                          <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                                        </button>
                                      </div>
                                    </ng-container>
  
                                    <ng-container *ngSwitchCase="'keyValue'">
                                      <div class="component-wrapper" [attr.data-component-id]="panelChild.id">
                                        <app-webhook-adapter-beta 
                                          [node]="panelChild" 
                                          [isPreview]="isPreviewMode">
                                        </app-webhook-adapter-beta>
                                        <button 
                                          *ngIf="isEditMode"
                                          nz-button 
                                          nzSize="small" 
                                          nzType="text" 
                                          nzShape="circle"
                                          [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                                          nz-tooltip
                                          (click)="onRemoveNode(panelChild, $event)"
                                          class="remove-button">
                                          <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                                        </button>
                                      </div>
                                    </ng-container>
  
                                    <ng-container *ngSwitchCase="'search'">
                                      <div class="component-wrapper" [attr.data-component-id]="panelChild.id" [attr.data-update-key]="panelChild.updateKey">
                                        <app-webhook-adapter-beta 
                                          [node]="panelChild" 
                                          [isPreview]="isPreviewMode"
                                          [attr.data-update-key]="panelChild.updateKey">
                                        </app-webhook-adapter-beta>
                                        <button 
                                          *ngIf="isEditMode"
                                          nz-button 
                                          nzSize="small" 
                                          nzType="text" 
                                          nzShape="circle"
                                          [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                                          nz-tooltip
                                          (click)="onRemoveNode(panelChild, $event)"
                                          class="remove-button">
                                          <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                                        </button>
                                      </div>
                                    </ng-container>
  
                                    <ng-container *ngSwitchCase="'querySelect'">
                                      <div class="component-wrapper" [attr.data-update-key]="panelChild.updateKey">
                                        <app-webhook-adapter-beta 
                                          [node]="panelChild" 
                                          [isPreview]="isPreviewMode"
                                          [attr.data-update-key]="panelChild.updateKey">
                                        </app-webhook-adapter-beta>
                                        <button 
                                          *ngIf="isEditMode"
                                          nz-button 
                                          nzSize="small" 
                                          nzType="text" 
                                          nzShape="circle"
                                          [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                                          nz-tooltip
                                          (click)="onRemoveNode(panelChild, $event)"
                                          class="remove-button">
                                          <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                                        </button>
                                      </div>
                                    </ng-container>
  
                                    <!-- ⭐ NOVO: Row - Container para campos lado a lado -->
                                    <ng-container *ngSwitchCase="'row'">
                                      <div class="row-container"
                                           [ngStyle]="{
                                             'background-color': panelChild.props?.backgroundColor || 'transparent',
                                             'border': isEditMode ? '2px dashed #1890ff' : 'none',
                                             'border-radius': '4px',
                                             'min-height': isEditMode ? '60px' : 'auto',
                                             'position': 'relative'
                                           }"
                                           [class.row-selected]="isEditMode && (builderService.selectedId$ | async) === panelChild.id">
                                        
                                        <!-- Label do Row - APENAS em modo de edição -->
                                        <div *ngIf="isEditMode" class="row-label" style="position: absolute; top: -10px; left: 8px; background: #1890ff; color: white; padding: 2px 8px; font-size: 11px; border-radius: 3px; z-index: 1;">
                                          <nz-icon nzType="column-width" nzTheme="outline"></nz-icon>
                                          {{ panelChild.props?.label || 'Linha' |translateTA }}
                                        </div>
  
                                        <!-- ✅ CORREÇÃO: Renderiza campos filhos do Row usando webhook-adapter para TODOS os tipos -->
                                        <ng-container *ngFor="let rowChild of getChildrenOfRow(nodes, panelChild.id); trackBy: trackById">
                                          <div class="row-child" 
                                               [ngStyle]="{
                                                 'grid-column': 'span ' + (rowChild.props?.colSpan || 24)
                                               }">
                                            
                                            <!-- ✅ RENDERIZAÇÃO UNIFICADA - webhook-adapter suporta todos os componentes -->
                                            <div class="canvas-node child"
                                                 [class.is-selected]="isEditMode && (builderService.selectedId$ | async) === rowChild.id"
                                                 (click)="isEditMode && builderService.selectNode(rowChild.id); $event.stopPropagation()">
                                              
                                              <div class="component-wrapper">
                                                <!-- ✅ USAR WEBHOOK-ADAPTER PARA TODOS: text, textarea, number, switch, button, image, search, tag, divider, etc. -->
                                                <app-webhook-adapter-beta 
                                                  [node]="rowChild" 
                                                  [isPreview]="isPreviewMode">
                                                </app-webhook-adapter-beta>
                                                
                                                <!-- Botão de remover -->
                                                <button 
                                                  *ngIf="isEditMode"
                                                  nz-button 
                                                  nzSize="small" 
                                                  nzType="text" 
                                                  nzShape="circle"
                                                  [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                                                  nz-tooltip
                                                  (click)="onRemoveNode(rowChild, $event)"
                                                  class="remove-button">
                                                  <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </ng-container>
  
                                        <!-- Mensagem quando Row está vazio - APENAS em modo de edição -->
                                        <div *ngIf="isEditMode && getChildrenOfRow(nodes, panelChild.id).length === 0" 
                                             style="flex: 1; text-align: center; color: #999; padding: 20px; font-size: 12px;">
                                          <nz-icon nzType="plus-circle" nzTheme="outline" style="font-size: 20px; margin-bottom: 8px;"></nz-icon>
                                          <div>Arraste campos para dentro desta linha</div>
                                          <div style="font-size: 11px; margin-top: 4px;">{{ 'builderScreen.canvas.row.sideBySideHint' | translateTA }}</div>
                                        </div>
  
                                        <!-- Botão para remover o Row - APENAS em modo de edição -->
                                        <button 
                                          *ngIf="isEditMode"
                                          nz-button 
                                          nzSize="small" 
                                          nzType="text" 
                                          nzShape="circle"
                                          nzDanger
                                          [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                                          nz-tooltip
                                          (click)="onRemoveNode(panelChild, $event)"
                                          style="position: absolute; top: 4px; right: 4px; z-index: 2;">
                                          <nz-icon nzType="delete" nzTheme="outline"></nz-icon>
                                        </button>
                                      </div>
                                    </ng-container>
  
                                    <ng-container *ngSwitchCase="'datagrid'">
                                      <div class="component-wrapper">
                                        <label class="node-label">{{ panelChild.props?.label |translateTA }}</label>
                                        <!-- CORREÇÃO: isTabGrid apenas para grades aninhadas (dataPath com 3+ segmentos) -->
                                        <app-data-grid
                                          [props]="panelChild.props"
                                          [effectiveDataPath]="panelChild.props?.dataPath"
                                          [isTabGrid]="isNestedDataPath(panelChild.props?.dataPath)"
                                          [previewMode]="panelChild.props?.previewMode"
                                          (flipStateChanged)="onFlipStateChanged($event)"
                                          (drawerStateChanged)="onDrawerStateChanged($event)">
                                        </app-data-grid>
                                        <button 
                                          *ngIf="isEditMode"
                                          nz-button 
                                          nzSize="small" 
                                          nzType="text" 
                                          nzShape="circle"
                                          [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                                          nz-tooltip
                                          (click)="onRemoveNode(panelChild, $event)"
                                          class="remove-button">
                                          <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                                        </button>
                                      </div>
                                    </ng-container>
  
                                    <!-- Case default para tipos realmente não reconhecidos -->
                                    <ng-container *ngSwitchDefault>
                                      <div class="component-wrapper">
                                        <label class="node-label">{{ panelChild.props?.label |translateTA }}</label>
                                        <div class="unknown-component">
                                          <nz-alert 
                                            nzType="warning" 
                                            nzMessage="Tipo não suportado: {{ panelChild.type }}"
                                            nzShowIcon>
                                          </nz-alert>
                                        </div>
                                        <button 
                                          *ngIf="isEditMode"
                                          nz-button 
                                          nzSize="small" 
                                          nzType="text" 
                                          nzShape="circle"
                                          [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                                          nz-tooltip
                                          (click)="onRemoveNode(panelChild, $event)"
                                          class="remove-button">
                                          <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                                        </button>
                                      </div>
                                    </ng-container>
                                  </ng-container>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </ng-container>
  
                      <!-- ⭐ NOVO: Row como filho direto da Tab -->
                      <ng-container *ngSwitchCase="'row'">
                        <div class="row-container"
                             [ngStyle]="{
                               'background-color': child.props?.backgroundColor || 'transparent',
                               'border': isEditMode ? '2px dashed #1890ff' : 'none',
                               'border-radius': '4px',
                               'min-height': isEditMode ? '60px' : 'auto',
                               'position': 'relative'
                             }"
                             [class.row-selected]="isEditMode && (builderService.selectedId$ | async) === child.id"
                             (click)="onSelectChild(child, $event)">
                          
                          <!-- Label do Row - APENAS em modo de edição -->
                          <div *ngIf="isEditMode" class="row-label" style="position: absolute; top: -10px; left: 8px; background: #1890ff; color: white; padding: 2px 8px; font-size: 11px; border-radius: 3px; z-index: 1;">
                            <nz-icon nzType="column-width" nzTheme="outline"></nz-icon>
                            {{ child.props?.label || 'Linha' |translateTA }}
                          </div>
  
                            <!-- ✅ CORREÇÃO: Renderiza campos filhos do Row usando webhook-adapter para TODOS os tipos -->
                            <ng-container *ngFor="let rowChild of getChildrenOfRow(nodes, child.id); trackBy: trackById">
                              <div class="row-child" 
                                   [ngStyle]="{
                                     'grid-column': 'span ' + (rowChild.props?.colSpan || 24)
                                   }">
                                
                                <!-- ✅ RENDERIZAÇÃO UNIFICADA - webhook-adapter suporta todos os componentes (básicos + avançados) -->
                                <div class="canvas-node child"
                                     [class.is-selected]="isEditMode && (builderService.selectedId$ | async) === rowChild.id"
                                     (click)="isEditMode && builderService.selectNode(rowChild.id); $event.stopPropagation()">
                                  
                                  <div class="component-wrapper">
                                    <!-- ✅ USAR WEBHOOK-ADAPTER PARA TODOS: text, textarea, number, switch, search, tag, divider, etc. -->
                                    <app-webhook-adapter-beta 
                                      [node]="rowChild" 
                                      [isPreview]="isPreviewMode">
                                    </app-webhook-adapter-beta>
                                    
                                    <!-- Botão de remover -->
                                    <button 
                                      *ngIf="isEditMode"
                                      nz-button 
                                      nzSize="small" 
                                      nzType="text" 
                                      nzShape="circle"
                                      [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                                      nz-tooltip
                                      (click)="onRemoveNode(rowChild, $event)"
                                      class="remove-button">
                                      <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </ng-container>
  
                            <!-- Mensagem quando Row está vazio - APENAS em modo de edição -->
                            <div *ngIf="isEditMode && getChildrenOfRow(nodes, child.id).length === 0" 
                                 style="flex: 1; text-align: center; color: #999; padding: 20px; font-size: 12px;">
                              <nz-icon nzType="plus-circle" nzTheme="outline" style="font-size: 20px; margin-bottom: 8px;"></nz-icon>
                              <div>Clique em campos na paleta para adicionar aqui</div>
                              <div style="font-size: 11px; margin-top: 4px;">{{ 'builderScreen.canvas.row.sideBySideHint' | translateTA }}</div>
                            </div>
  
                            <!-- Botão para remover o Row - APENAS em modo de edição -->
                            <button 
                              *ngIf="isEditMode"
                              nz-button 
                              nzSize="small" 
                              nzType="text" 
                              nzShape="circle"
                              nzDanger
                              [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                              nz-tooltip
                              (click)="onRemoveNode(child, $event)"
                              style="position: absolute; top: 4px; right: 4px; z-index: 2;">
                              <nz-icon nzType="delete" nzTheme="outline"></nz-icon>
                            </button>
                          </div>
                        </ng-container>
  
                        <ng-container *ngSwitchDefault>
                          <div class="component-wrapper" *ngIf="isWebhookComponent(child.type); else unknownChild">
                            <app-webhook-adapter-beta 
                              [node]="child" 
                              [isPreview]="isPreviewMode">
                            </app-webhook-adapter-beta>
                            <button 
                              nz-button 
                              nzSize="small" 
                              nzType="text" 
                              nzShape="circle"
                              [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                              [attr.aria-label]="'builderScreen.canvas.remove' |translateTA"
                              nz-tooltip
                              (click)="onRemoveNode(child, $event)"
                              class="remove-button">
                              <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                            </button>
                          </div>
                          <ng-template #unknownChild>
                            <span>{{ child.type }}</span>
                          </ng-template>
                        </ng-container>
                      </ng-container>
                    </div>
                  </ng-container>
                </div>
              </nz-tab>
            </nz-tabs>
            <div class="tabs-actions">
              <button 
                *ngIf="getActiveTabId(node)"
                nz-button 
                nzSize="small" 
                nzType="text" 
                nzShape="circle"
                nzDanger
                [nzTitle]="'builderScreen.canvas.removeTabs' |translateTA"
                [attr.aria-label]="'builderScreen.canvas.removeTabs' |translateTA"
                nz-tooltip
                (click)="onRemoveTab(node, getActiveTabId(node)!, $event)"
                class="remove-button">
                <nz-icon nzType="close" nzTheme="outline"></nz-icon>
              </button>
            </div>
          </ng-container>
  
          <ng-container *ngSwitchCase="'panel'">
            <div class="panel-container" 
                 [ngStyle]="getPanelStyles(node)"
                 [class.panel-selected]="(builderService.selectedId$ | async) === node.id"
                 [class.panel-active]="node.props?.active"
                 [class.panel-collapsed]="node.props?.collapsed">
              
              <!-- Header do panel com nome e controles -->
              <div class="panel-header">
                <div class="panel-title">
                  <nz-icon nzType="layout" nzTheme="outline"></nz-icon>
                  <span>{{ node.props?.name || 'Panel' |translateTA }}</span>
                  <nz-tag *ngIf="node.props?.active" nzColor="processing" nzSize="small">
                    {{ 'builderScreen.panel.active' |translateTA }}
                  </nz-tag>
                </div>
                
                <!-- Botões de controle (igual outros componentes) -->
                <div class="panel-controls">
                  <button
                    nz-button
                    nzSize="small"
                    nzType="text"
                    nzShape="circle"
                    [nzTitle]="'builderScreen.panel.collapse' |translateTA"
                    nz-tooltip
                    (click)="togglePanelCollapse(node)"
                    class="collapse-button">
                    <nz-icon
                      [nzType]="node.props?.collapsed ? 'down' : 'up'"
                      nzTheme="outline">
                    </nz-icon>
                  </button>
                  
                  <button
                    nz-button
                    nzSize="small"
                    nzType="text"
                    nzShape="circle"
                    nzDanger
                    [nzTitle]="'builderScreen.canvas.removePanel' |translateTA"
                    nz-tooltip
                    (click)="onRemoveNode(node, $event)"
                    class="remove-button">
                    <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                  </button>
                </div>
              </div>
              
              <!-- Conteúdo do panel (fields filhos) -->
              <div class="panel-content" 
                   [attr.data-add-fields-text]="'builderScreen.panel.addFields' |translateTA"
                   *ngIf="!node.props?.collapsed">
                <ng-container *ngFor="let child of getChildrenForPanel(nodes, node.id); trackBy: trackById">
                  <!-- Renderizar fields filhos usando o sistema existente -->
                  <div class="canvas-node child"
                       [class.selected]="(builderService.selectedId$ | async) === child.id"
                       [hidden]="shouldHideNonGridChild(node.id, child.type)"
                       (click)="onSelectChild(child, $event)"
                       [ngStyle]="getGridStyle(getPanelChildGridPosition(child.id, node.id, nodes), child.props, node.id)">
                    <!-- Usar o mesmo sistema de renderização existente -->
                    <ng-container [ngSwitch]="child.type">
                      <!-- Cases existentes para text, number, etc. serão reutilizados -->
                      <ng-container *ngSwitchCase="'text'">
                        <div class="component-wrapper">
                          <label class="node-label">{{ child.props?.label |translateTA }}</label>
                          <input nz-input 
                            [attr.data-component-id]="child.id"
                            [placeholder]="(child.props?.placeholder |translateTA) || ''" 
                            [ngStyle]="{
                              'background-color': child.props?.backgroundColor || null,
                              'color': child.props?.textColor || null
                            }" />
                            <button 
                              nz-button 
                              nzSize="small" 
                              nzType="text" 
                              nzShape="circle"
                              [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                              nz-tooltip
                              (click)="onRemoveNode(child, $event)"
                              class="remove-button">
                              <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                            </button>
                        </div>
                      </ng-container>
  
                      <ng-container *ngSwitchCase="'textarea'">
                        <div class="component-wrapper">
                          <label class="node-label">{{ child.props?.label |translateTA }}</label>
                          <textarea nz-input 
                            [attr.data-component-id]="child.id"
                            [nzAutosize]="{ minRows: child.props?.minRows || 3, maxRows: child.props?.minRows || 6 }"
                            [placeholder]="(child.props?.placeholder |translateTA) || ''"
                            [ngStyle]="{
                              'background-color': child.props?.backgroundColor || null,
                              'color': child.props?.textColor || null
                            }">
                          </textarea>
                          <button 
                            nz-button 
                            nzSize="small" 
                            nzType="text" 
                            nzShape="circle"
                            [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                            nz-tooltip
                            (click)="onRemoveNode(child, $event)"
                            class="remove-button">
                            <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                          </button>
                        </div>
                      </ng-container>
  
                      <ng-container *ngSwitchCase="'number'">
                        <div class="component-wrapper">
                          <label class="node-label">{{ child.props?.label |translateTA }}</label>
                          <nz-input-number 
                            [attr.data-component-id]="child.id"
                            [nzPlaceHolder]="(child.props?.placeholder |translateTA) || ''"
                            [nzMin]="child.props?.min || null"
                            [nzMax]="child.props?.max || null"
                            [nzStep]="child.props?.step || 1"
                            [nzPrecision]="child.props?.precision || null"
                            [ngStyle]="{
                              'background-color': child.props?.backgroundColor || null,
                              'color': child.props?.textColor || null
                            }">
                          </nz-input-number>
                          <button 
                            nz-button 
                            nzSize="small" 
                            nzType="text" 
                            nzShape="circle"
                            [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                            nz-tooltip
                            (click)="onRemoveNode(child, $event)"
                            class="remove-button">
                            <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                          </button>
                        </div>
                      </ng-container>
  
                      <ng-container *ngSwitchCase="'switch'">
                        <div class="component-wrapper" 
                             [ngStyle]="{
                               'background-color': child.props?.backgroundColor || null,
                               'color': child.props?.textColor || null
                             }">
                          <label class="node-label">{{ child.props?.label |translateTA }}</label>
                          <nz-switch 
                            [attr.data-component-id]="child.id"
                            [nzChecked]="child.props?.defaultValue || false"
                            [nzCheckedChildren]="child.props?.checkedChildren || ''"
                            [nzUnCheckedChildren]="child.props?.unCheckedChildren || ''"
                            (nzCheckedChange)="onSwitchChange(child, $event)">
                          </nz-switch>
                          <button 
                            nz-button 
                            nzSize="small" 
                            nzType="text" 
                            nzShape="circle"
                            [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                            nz-tooltip
                            (click)="onRemoveNode(child, $event)"
                            class="remove-button">
                            <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                          </button>
                        </div>
                      </ng-container>

                      <!-- NOVO: Dropdown (combo-box básico) dentro de Tab -->
                      <ng-container *ngSwitchCase="'dropdown'">
                        <div class="component-wrapper">
                          <label class="node-label">{{ child.props?.label |translateTA }}</label>
                          <nz-select
                            [attr.data-component-id]="child.id"
                            [nzPlaceHolder]="(child.props?.placeholder |translateTA) || 'Selecione uma opção'"
                            [nzMode]="child.props?.multiple ? 'multiple' : 'default'"
                            [nzShowSearch]="child.props?.showSearch || false"
                            [ngStyle]="{
                              'background-color': child.props?.backgroundColor || null,
                              'color': child.props?.textColor || null,
                              'width': '100%'
                            }">
                            <nz-option 
                              *ngFor="let option of child.props?.options" 
                              [nzValue]="option.value" 
                              [nzLabel]="option.label">
                            </nz-option>
                          </nz-select>
                          <button 
                            nz-button 
                            nzSize="small" 
                            nzType="text" 
                            nzShape="circle"
                            [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                            nz-tooltip
                            (click)="onRemoveNode(child, $event)"
                            class="remove-button">
                            <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                          </button>
                        </div>
                      </ng-container>
  
                      <ng-container *ngSwitchCase="'button'">
                        <div class="component-wrapper">
                          <button 
                            nz-button 
                            [attr.data-component-id]="child.id"
                            [nzType]="child.props?.buttonType || 'default'"
                            [nzSize]="child.props?.size || 'default'"
                            [nzLoading]="child.props?.loading || false"
                            [disabled]="child.props?.disabled || false"
                            [ngStyle]="{
                              'background-color': child.props?.backgroundColor || null,
                              'color': child.props?.textColor || null,
                              'border-color': child.props?.backgroundColor || null
                            }"
                            (click)="onButtonClick(child, $event)">
                            <nz-icon *ngIf="child.props?.icon" [nzType]="child.props?.icon"></nz-icon>
                            {{ child.props?.text || 'Button' }}
                          </button>
                          <button 
                            nz-button 
                            nzSize="small" 
                            nzType="text" 
                            nzShape="circle"
                            [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                            nz-tooltip
                            (click)="onRemoveNode(child, $event)"
                            class="remove-button">
                            <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                          </button>
                        </div>
                      </ng-container>
  
                      <ng-container *ngSwitchCase="'datagrid'">
                        <div class="component-wrapper">
                          <label class="node-label">{{ child.props?.label |translateTA }}</label>
                          <app-data-grid
                            [props]="child.props"
                            [effectiveDataPath]="getEffectiveDataPathForTabGrid(node, t, child)"
                            [isTabGrid]="true"
                            [previewMode]="child.props?.previewMode"
                            (flipStateChanged)="onFlipStateChanged($event)"
                            (drawerStateChanged)="onDrawerStateChanged($event)">
                          </app-data-grid>
                          <button 
                            nz-button 
                            nzSize="small" 
                            nzType="text" 
                            nzShape="circle"
                            [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                            nz-tooltip
                            (click)="onRemoveNode(child, $event)"
                            class="remove-button">
                            <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                          </button>
                        </div>
                      </ng-container>
  
                      <!-- Case default para componentes não reconhecidos -->
                      <ng-container *ngSwitchDefault>
                        <div class="component-wrapper">
                          <label class="node-label">{{ child.props?.label |translateTA }}</label>
                          <div class="unknown-component">
                            <nz-alert 
                              nzType="warning" 
                              nzMessage="Componente não suportado: {{ child.type }}"
                              nzShowIcon>
                            </nz-alert>
                          </div>
                          <button 
                            nz-button 
                            nzSize="small" 
                            nzType="text" 
                            nzShape="circle"
                            [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                            nz-tooltip
                            (click)="onRemoveNode(child, $event)"
                            class="remove-button">
                            <nz-icon nzType="close" nzTheme="outline"></nz-icon>
                          </button>
                        </div>
                      </ng-container>
  
                      <!-- Adicionar mais cases conforme necessário -->
                    </ng-container>
                  </div>
                </ng-container>
                
              </div>
            </div>
          </ng-container>
  
          <ng-container *ngSwitchCase="'number'">
            <div class="component-wrapper">
              <label class="node-label">{{ node.props?.label |translateTA }}</label>
              <nz-input-number 
                [attr.data-component-id]="node.id"
                [nzPlaceHolder]="(node.props?.placeholder |translateTA) || ''"
                [nzMin]="node.props?.min || 0"
                [nzMax]="node.props?.max || 100"
                [nzStep]="node.props?.step || 1"
                [nzPrecision]="node.props?.precision || 0"
                [ngStyle]="{
                  'background-color': node.props?.backgroundColor || null,
                  'color': node.props?.textColor || null
                }">
              </nz-input-number>
              <button 
                nz-button 
                nzSize="small" 
                nzType="text" 
                nzShape="circle"
                [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                [attr.aria-label]="'builderScreen.canvas.remove' |translateTA"
                nz-tooltip
                (click)="onRemoveNode(node, $event)"
                class="remove-button">
                <nz-icon nzType="close" nzTheme="outline"></nz-icon>
              </button>
            </div>
          </ng-container>
  
          <ng-container *ngSwitchCase="'switch'">
            <div class="component-wrapper" 
              [ngStyle]="{
                'background-color': node.props?.backgroundColor || null,
                'color': node.props?.textColor || null
              }">
              <label class="node-label">{{ node.props?.label |translateTA }}</label>
              <nz-switch 
                [attr.data-component-id]="node.id"
                [nzCheckedChildren]="node.props?.checkedChildren |translateTA"
                [nzUnCheckedChildren]="node.props?.unCheckedChildren |translateTA"
                [nzChecked]="node.props?.defaultValue || false"
                (nzCheckedChange)="onSwitchChange(node, $event)">
              </nz-switch>
              <button 
                nz-button 
                nzSize="small" 
                nzType="text" 
                nzShape="circle"
                [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                [attr.aria-label]="'builderScreen.canvas.remove' |translateTA"
                nz-tooltip
                (click)="onRemoveNode(node, $event)"
                class="remove-button">
                <nz-icon nzType="close" nzTheme="outline"></nz-icon>
              </button>
            </div>
          </ng-container>

          <!-- NOVO: Dropdown (combo-box básico) no root -->
          <ng-container *ngSwitchCase="'dropdown'">
            <div class="component-wrapper">
              <label class="node-label">{{ node.props?.label |translateTA }}</label>
              <nz-select
                [attr.data-component-id]="node.id"
                [nzPlaceHolder]="(node.props?.placeholder |translateTA) || 'Selecione uma opção'"
                [nzMode]="node.props?.multiple ? 'multiple' : 'default'"
                [nzShowSearch]="node.props?.showSearch || false"
                [ngStyle]="{
                  'background-color': node.props?.backgroundColor || null,
                  'color': node.props?.textColor || null,
                  'width': '100%'
                }">
                <nz-option 
                  *ngFor="let option of node.props?.options" 
                  [nzValue]="option.value" 
                  [nzLabel]="option.label">
                </nz-option>
              </nz-select>
              <button 
                nz-button 
                nzSize="small" 
                nzType="text" 
                nzShape="circle"
                [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                [attr.aria-label]="'builderScreen.canvas.remove' |translateTA"
                nz-tooltip
                (click)="onRemoveNode(node, $event)"
                class="remove-button">
                <nz-icon nzType="close" nzTheme="outline"></nz-icon>
              </button>
            </div>
          </ng-container>
  
          <ng-container *ngSwitchCase="'button'">
            <div class="component-wrapper">
              <label class="node-label">{{ node.props?.label |translateTA }}</label>
              <button 
                nz-button 
                [nzType]="node.props?.buttonType || 'default'"
                [nzSize]="node.props?.size || 'default'"
                [nzLoading]="node.props?.loading || false"
                [disabled]="node.props?.disabled || false"
                [ngStyle]="{
                  'background-color': node.props?.backgroundColor || null,
                  'color': node.props?.textColor || null,
                  'border-color': node.props?.backgroundColor || null
                }"
                (click)="onButtonClick(node, $event)"
                class="canvas-button">
                <nz-icon *ngIf="node.props?.icon" [nzType]="node.props.icon"></nz-icon>
                {{ node.props?.text || ('builderScreen.button.defaultText' |translateTA) }}
              </button>
              <button 
                nz-button 
                nzSize="small" 
                nzType="text" 
                nzShape="circle"
                [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                [attr.aria-label]="'builderScreen.canvas.remove' |translateTA"
                nz-tooltip
                (click)="onRemoveNode(node, $event)"
                class="remove-button">
                <nz-icon nzType="close" nzTheme="outline"></nz-icon>
              </button>
            </div>
          </ng-container>
  
          <ng-container *ngSwitchCase="'simpletable'">
            <div class="component-wrapper">
              <label class="node-label">{{ node.props?.label |translateTA }}</label>
              <nz-table 
                [nzData]="node.props?.dataSource || []"
                [nzShowPagination]="false"
                nzSize="small"
                [ngStyle]="{
                  '--table-header-bg': node.props?.headerBackgroundColor || null,
                  '--table-header-color': node.props?.headerTextColor || null,
                  '--table-row-bg': node.props?.rowBackgroundColor || null,
                  '--table-row-color': node.props?.rowTextColor || null,
                  '--table-alt-row-bg': node.props?.alternateRowColor || null,
                  '--table-border-color': node.props?.borderColor || null,
                  '--table-hover-color': node.props?.hoverColor || null
                }">
                <thead>
                  <tr>
                    <th *ngFor="let col of node.props?.columns || []; trackBy: trackByColumnKey">{{ col.label |translateTA }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of node.props?.dataSource || []; let i = index; trackBy: trackByIndex">
                    <td *ngFor="let col of node.props?.columns || []; trackBy: trackByColumnKey">{{ data[col.key] }}</td>
                  </tr>
                </tbody>
              </nz-table>
              <button 
                nz-button 
                nzSize="small" 
                nzType="text" 
                nzShape="circle"
                [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                [attr.aria-label]="'builderScreen.canvas.remove' |translateTA"
                nz-tooltip
                (click)="onRemoveNode(node, $event)"
                class="remove-button">
                <nz-icon nzType="close" nzTheme="outline"></nz-icon>
              </button>
            </div>
          </ng-container>
  
          <ng-container *ngSwitchCase="'table'">
            <div class="component-wrapper">
              <label class="node-label">{{ node.props?.label |translateTA }}</label>
              <nz-table 
                [nzData]="node.props?.dataSource || []"
                [nzShowPagination]="node.props?.pagination || true"
                nzSize="small"
                [ngStyle]="{
                  '--table-header-bg': node.props?.headerBackgroundColor || null,
                  '--table-header-color': node.props?.headerTextColor || null,
                  '--table-row-bg': node.props?.rowBackgroundColor || null,
                  '--table-row-color': node.props?.rowTextColor || null,
                  '--table-alt-row-bg': node.props?.alternateRowColor || null,
                  '--table-border-color': node.props?.borderColor || null,
                  '--table-hover-color': node.props?.hoverColor || null
                }">
                <thead>
                  <tr>
                    <th 
                      *ngFor="let col of node.props?.columns || []; trackBy: trackByColumnKey"
                      [nzSortFn]="node.props?.sorting ? true : null"
                      [nzShowFilter]="node.props?.filtering || false">
                      {{ col.label |translateTA }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of node.props?.dataSource || []; let i = index; trackBy: trackByIndex">
                    <td *ngFor="let col of node.props?.columns || []; trackBy: trackByColumnKey">{{ data[col.key] }}</td>
                  </tr>
                </tbody>
              </nz-table>
              <button 
                nz-button 
                nzSize="small" 
                nzType="text" 
                nzShape="circle"
                [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                [attr.aria-label]="'builderScreen.canvas.remove' |translateTA"
                nz-tooltip
                (click)="onRemoveNode(node, $event)"
                class="remove-button">
                <nz-icon nzType="close" nzTheme="outline"></nz-icon>
              </button>
            </div>
          </ng-container>
  
          <ng-container *ngSwitchCase="'datagrid'">
            <div class="component-wrapper">
              <label class="node-label">{{ node.props?.label |translateTA }}</label>
              <app-data-grid
                [props]="node.props"
                [previewMode]="node.props?.previewMode"
                (flipStateChanged)="onFlipStateChanged($event)"
                (drawerStateChanged)="onDrawerStateChanged($event)">
              </app-data-grid>
              <button 
                nz-button 
                nzSize="small" 
                nzType="text" 
                nzShape="circle"
                [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                [attr.aria-label]="'builderScreen.canvas.remove' |translateTA"
                nz-tooltip
                (click)="onRemoveNode(node, $event)"
                class="remove-button">
                <nz-icon nzType="close" nzTheme="outline"></nz-icon>
              </button>
            </div>
          </ng-container>
  
          <ng-container *ngSwitchCase="'spreadsheet'">
            <div class="component-wrapper">
              <label class="node-label">{{ node.props?.label |translateTA }}</label>
              <app-builder-spreadsheet 
                [props]="node.props">
              </app-builder-spreadsheet>
              <button 
                nz-button 
                nzSize="small" 
                nzType="text" 
                nzShape="circle"
                [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                [attr.aria-label]="'builderScreen.canvas.remove' |translateTA"
                nz-tooltip
                (click)="onRemoveNode(node, $event)"
                class="remove-button">
                <nz-icon nzType="close" nzTheme="outline"></nz-icon>
              </button>
            </div>
          </ng-container>
  
          <ng-container *ngSwitchDefault>
            <div class="component-wrapper" *ngIf="isWebhookComponent(node.type); else unknownComponent">
              <app-webhook-adapter-beta 
                [node]="node" 
                [isPreview]="isPreviewMode">
              </app-webhook-adapter-beta>
              <button 
                nz-button 
                nzSize="small" 
                nzType="text" 
                nzShape="circle"
                [nzTitle]="'builderScreen.canvas.remove' |translateTA"
                [attr.aria-label]="'builderScreen.canvas.remove' |translateTA"
                nz-tooltip
                (click)="onRemoveNode(node, $event)"
                class="remove-button">
                <nz-icon nzType="close" nzTheme="outline"></nz-icon>
              </button>
            </div>
            <ng-template #unknownComponent>
              <span>{{ node.type }}</span>
            </ng-template>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
  
     <!-- ⭐ NOVO: Master-Detail Panel -->
    <app-master-detail-panel
      *ngIf="activeMasterDetailPanel"
      [formPanelId]="activeMasterDetailPanel.formPanelId"
      [mode]="getMasterDetailMode()"
      [autoOpen]="false"
      [defaultWidth]="40"
      (closed)="onMasterDetailPanelClosed()">
      <!-- Conteúdo do formulário será renderizado aqui dinamicamente -->
    </app-master-detail-panel>

    <!-- Drawer Mode: Gaveta lateral com formulários -->
    <nz-drawer
      [nzVisible]="isDrawerVisible"
      [nzWidth]="drawerWidth.toString() + '%'"
      nzPlacement="right"
      [nzTitle]="'builderScreen.canvas.editRecord' | translateTA"
      [nzClosable]="true"
      (nzOnClose)="onDrawerClose()">
      <ng-container *nzDrawerContent>
        <div style="padding: 8px;">
          <ng-container *ngFor="let panelId of drawerPanelIds">
            <ng-container *ngFor="let node of (builderService.nodes$ | async) || []">
              <ng-container *ngIf="node.id === panelId && node.type === 'panel'">
                <div style="margin-bottom: 16px;">
                  <h4 style="margin-bottom: 12px; color: #1890ff; display: flex; align-items: center; gap: 8px;">
                    <i nz-icon nzType="layout" nzTheme="outline"></i>
                    {{ node.props?.name || 'Panel' | translateTA }}
                  </h4>
                  <ng-container *ngFor="let child of getChildrenForPanel((builderService.nodes$ | async) || [], panelId)">
                    <ng-container *ngIf="child.type === 'row'">
                      <div style="display: grid; grid-template-columns: repeat(24, 1fr); gap: 8px; margin-bottom: 12px; padding: 8px; border: 1px dashed rgba(255,255,255,0.15); border-radius: 4px;">
                        <ng-container *ngFor="let rowChild of getChildrenOfRow((builderService.nodes$ | async) || [], child.id)">
                          <div [ngStyle]="{'grid-column': 'span ' + (rowChild.props?.colSpan || 24)}" style="margin-bottom: 4px;">
                            <app-webhook-adapter-beta
                              [node]="rowChild"
                              [isPreview]="isPreviewMode">
                            </app-webhook-adapter-beta>
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                    <div style="margin-bottom: 8px;" *ngIf="child.type !== 'datagrid' && child.type !== 'row'">
                      <app-webhook-adapter-beta
                        [node]="child"
                        [isPreview]="isPreviewMode">
                      </app-webhook-adapter-beta>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </nz-drawer>
  
  </ng-container>
  
  <ng-template #empty>
    <div class="canvas-empty">
      {{ 'builderScreen.canvas.empty' |translateTA }}
    </div>
  </ng-template>
  
  
  